import { create } from "zustand";

interface UserData {
    name: string | null;
    familyName: string | null;
    email: string | null;
    phoneNumber: string | null;
    taxCode: string | null;
    swabcode: string | null;
    bloodcodes: string[] | null;
    acceptedPrivacyVersion: string | null;
    acceptedPrivacyAt: string | null;
    d1Consent: boolean | null;
    d1ConsentAt: string | null;
}

interface UserDataState {
    name: string | null;
    familyName: string | null;
    email: string | null;
    phoneNumber: string | null;
    taxCode: string | null;
    swabcode: string | null;
    bloodcodes: string[] | null;
    acceptedPrivacyVersion: string | null;
    acceptedPrivacyAt: string | null;
    d1Consent: boolean | null;
    d1ConsentAt: string | null;
}

interface UserStore {
    userData: UserData
    updateUserData: (updates: Partial<UserDataState>) => void;
    clearUserData: () => void;
}

// Zustand store
export const useUserStore = create<UserStore>((set) => ({
    userData: JSON.parse(localStorage.getItem("userData") || "{}") as UserData || {
        name: null,
        familyName: null,
        email: null,
        phoneNumber: null,
        taxCode: null,
        swabcode: null,
        bloodcodes: null,
    },

    updateUserData: (updates) => {
        set((state) => {
            const newUserData = { ...state.userData, ...updates };
            localStorage.setItem("userData", JSON.stringify(newUserData));
            return { userData: newUserData };
        });
    },

    clearUserData: () => {
        set({ userData: { name: null, familyName: null, email: null, phoneNumber: null, taxCode: null, swabcode: null, bloodcodes: null, acceptedPrivacyVersion: null, acceptedPrivacyAt: null, d1Consent: null, d1ConsentAt: null } });
        localStorage.removeItem("userData");
    },
}));